import { render, staticRenderFns } from "./ddoWaiting.vue?vue&type=template&id=b7b7f7c0&"
import script from "./ddoWaiting.vue?vue&type=script&lang=js&"
export * from "./ddoWaiting.vue?vue&type=script&lang=js&"
import style0 from "./ddoWaiting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VDialog,VLayout,VProgressCircular})
